module.exports = __webpack_public_path__ + "static/media/toolbar-drag.71fcd2e0.svg";